export default () => {
  // MOBILE MENU
  let mobileMenu = document.querySelector('.Menu--Mobile');

  if (mobileMenu) {
    let firstLevelItems = mobileMenu.querySelectorAll('[data-level="0"]');
    if (firstLevelItems) {
      firstLevelItems.forEach((item) => {
        if (item.querySelector('.Menu__ItemWrapper')) {          
          item.querySelector('.Menu__ItemWrapper').addEventListener('click', () => {
            item.classList.toggle('is-active');
          });
        }
      });
    }
    let secondLevelItems = mobileMenu.querySelectorAll('[data-level="1"]');
    if (secondLevelItems) {
      secondLevelItems.forEach((item) => {
        if (item.querySelector('.Menu__ItemWrapper')) {
          item.querySelector('.Menu__ItemWrapper').addEventListener('click', e => {
            e.preventDefault();
            item.classList.toggle('is-active');
          });
        }
      });
    }
  }
  
  // DESKTOP MENU
  let desktopMenu = document.querySelector('.Menu--Desktop');

  if (desktopMenu) {
    let firstLevelItems = desktopMenu.querySelectorAll('[data-level="0"]');
    if (firstLevelItems) {
      firstLevelItems.forEach((item) => {
        if (item.classList.contains('has_children')) {
          item.addEventListener('mouseenter', e => {
            desktopMenu.querySelector('.Menu__Wrapper').classList.add('is-active');
            let secondLevel = e.currentTarget.querySelectorAll('.Menu__Item[data-level="1"]');
            if (secondLevel) {
              secondLevel[0].classList.add('is-active');

              secondLevel.forEach(element => {
                element.querySelector('a').setAttribute('href', 'javascript:void(0)');
                element.addEventListener('mouseenter', () => {
                  setActiveInList(secondLevel, element);
                })
              });
            }
          })
  
          item.addEventListener('mouseleave', e => {
            desktopMenu.querySelector('.Menu__Wrapper').classList.remove('is-active');
            let secondLevel = e.currentTarget.querySelectorAll('.Menu__Item[data-level="1"]');
            if (secondLevel) {
              secondLevel.forEach(element => {
                element.classList.remove('is-active');
              })
            }
          })
        }
      });
    }
  }
}

const setActiveInList = (list, active) => {
  list.forEach(item => {
    if (item.classList.contains('is-active')) {
      item.classList.remove('is-active');
    }
  });
  active.classList.add('is-active');
}
